export default {
  productCardWarranty: {
    id: 'pthumbs_warranty_new',
    defaultMessage: 'Warranty: {warranty}',
  },
  startingFrom: {
    id: 'list_view_starting_from',
    defaultMessage: 'Starting from:',
  },
  originalPriceAriaLabel: {
    id: 'product_thumb_original_price_aria_label',
    defaultMessage: 'Instead of { originalPrice }',
  },
  notDefinedAttribute: {
    id: 'list_view_not_defined_attribute',
    defaultMessage: 'ND',
  },
  recoTag: {
    id: 'product_thumb_reco_tag',
    defaultMessage: 'Good deal',
  },
  colorSwatches: {
    id: 'color_swatches_label',
    defaultMessage: 'Color: { color }',
  },
  moreColors: {
    id: 'color_swatches_more',
    defaultMessage: 'more colors',
  },
  moreStorages: {
    id: 'storages_swatches_more',
    defaultMessage: 'more storages',
  },
  storageLabel: {
    id: 'storage_label',
    defaultMessage: 'Storage: ',
  },
  colorsLabel: {
    id: 'color_label',
    defaultMessage: 'Colors: ',
  },
  loading: {
    id: 'loading_product_card',
    defaultMessage: 'Loading',
  },
}
